const updateValidation = (field, newValidation = {}) => Object.assign({}, field, {
  validation: Object.assign({}, field.validation, newValidation)
});
export default updateValidation;